import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import {Variation} from '@emm/common-items/models/variation.model';

export interface LocaleOption {
    value: string;
    label: string;
    bold?: boolean;
    disabled?: boolean;
}

@Component({
    selector: 'emm-selection-panel',
    templateUrl: './selection-panel.component.html',
    styleUrls: ['./selection-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SelectionPanelComponent {

    @Input() showDatePicker = true;
    @Input() dateLabel = 'Effective Date';
    @Input() localeLabel = 'Country/Locale';
    @Input() saveLabel = 'Save';
    @Input() showButtons = false;
    @Input() showCreate = true;
    @Input() createDisabled = false;
    @Input() busy = false;
    @Input() locale: string | null = null;
    @Input() selectedVariation = 'BASE_ITEM';
    @Input() variations: Variation[];
    @Input() item;
    @Input() assignments: any[];
    @Input() locales: LocaleOption[] = [
        { value: 'US', label: 'US', bold: true },
        { value: 'en-US', label: 'English US' },
        { value: 'CA', label: 'Canada', bold: true },
        { value: 'en-CA', label: 'English Canada' },
        { value: 'PR', label: 'Puerto Rico', bold: true },
        { value: 'en-PR', label: 'English Puerto Rico' },
        { value: 'es-PR', label: 'Spanish Puerto Rico' },
    ];

    @Input() effectiveDate: Date | null = null;
    @Input() minDate: Date | null = null;
    @Output() effectiveDateChange = new EventEmitter<Date | null>();
    @Output() localeChange = new EventEmitter<string | null>();
    @Output() variationChange = new EventEmitter<Variation | null>();
    @Output() create = new EventEmitter<void>();
    baseVariation: Variation = {
        itemTag: 'BASE_ITEM',
        variationTag: 'BASE_ITEM',
        variationLabel: 'Base Item',
        variationDescription: 'Base Item',
        locationId: 'CHAIN',
        overrides: {}
    };

    get showUnassigned(): boolean {
        return this.selectedVariation !== 'BASE_ITEM' && this.assignments.length === 0;
    }

    onCreateClick() {
        if (!this.createDisabled && !this.busy) {
            this.create.emit();
        }
    }

    onDateChange(event: any) {
        let value: Date | null = event?.value ?? null;
        if (this.minDate && value && value < this.minDate) {
            value = this.minDate;
        }
        this.effectiveDateChange.emit(value);
    }

    onLocaleChange(value: string | null) {
        this.localeChange.emit(value);
    }

    onVariationChange(value: string | null) {
        const variant = this.variations.find(variation => variation.variationTag === value);
        this.variationChange.emit(variant);
    }
}
